"server-only";
import { publicConfig } from "./constants";
import { ServerConfig } from "./types";

export default {
  ...publicConfig,
  contentful: {
    spaceId: process.env.CONTENTFUL_SPACE_ID,
    environmentId: process.env.CONTENTFUL_ENVIRONMENT_ID,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
  },
  alchemy: {
    key: process.env.ALCHEMY_KEY,
    rpc: process.env.ALCHEMY_RPC_URL,
  },
} as ServerConfig;
